import type { Updater } from '@tanstack/vue-table'
import type { Ref } from 'vue'
import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function valueUpdater<T extends Updater<any>>(updaterOrValue: T, ref: Ref) {
  ref.value
    = typeof updaterOrValue === 'function'
      ? updaterOrValue(ref.value)
      : updaterOrValue
}

/**
 * Get duck image URL based on rarity
 * Falls back to individual duck image if rarity is not provided
 */
export function getDuckImageUrl(duck: { rarity?: 'COMMON' | 'RARE' | 'LEGENDARY'; image?: string }) {
  // If duck has rarity, use rarity-based image
  if (duck.rarity) {
    return `/duckRarity/${duck.rarity}.webp`;
  }
  
  // Fallback to individual duck image or default
  if (duck.image) {
    return duck.image.startsWith('data:') 
      ? duck.image 
      : `data:image/webp;base64,${duck.image}`;
  }
  
  // Default fallback
  return '/ducksImages/duckIcon.webp';
}

/**
 * Get consistent rarity border classes for duck images
 */
export function getRarityBorderClass(rarity?: 'COMMON' | 'RARE' | 'LEGENDARY') {
  if (!rarity) return '';
  
  switch (rarity) {
    case 'COMMON':
      return 'border-green-400';
    case 'RARE':
      return 'border-blue-400';
    case 'LEGENDARY':
      return 'border-purple-400';
    default:
      return '';
  }
}

/**
 * Get rarity border shadow classes for enhanced visual effects
 */
export function getRarityBorderShadow(rarity?: 'COMMON' | 'RARE' | 'LEGENDARY') {
  if (!rarity) return '';
  
  switch (rarity) {
    case 'COMMON':
      return 'shadow-green-200';
    case 'RARE':
      return 'shadow-blue-200';
    case 'LEGENDARY':
      return 'shadow-purple-200';
    default:
      return '';
  }
}
